// Story 213 — how the HTTP layer tells the vision guard what Sun said, without React and without
// importing the guard (Api_Functions.jsx and Assistant_Api.jsx call these, as they call
// notifyServerConnectionLost).

const WORKSTATION_COVERED_STATUS = 423

const listeners = new Set()

// S142: a 423 can arrive while MIC starts up, before any guard listens; it is remembered.
let workstationCoveredReported = false

export const subscribeVisionSignals = (listener) => {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

const emit = (signal) => listeners.forEach((listener) => listener(signal))

export const isWorkstationCovered = (status) => status === WORKSTATION_COVERED_STATUS

// C1 step 4: any 423 in any call activates the guard.
export const reportWorkstationCovered = () => {
  workstationCoveredReported = true
  emit('covered')
}

export const wasWorkstationCoveredReported = () => workstationCoveredReported

// Only for tests: each one starts as a fresh page.
export const resetVisionSignals = () => {
  workstationCoveredReported = false
  listeners.clear()
}

// The caller's screen is being unmounted: its request must neither resolve nor fail, so no screen shows
// an alert or the 423 literal outside the overlay (S97, S98).
export const neverSettles = () => new Promise(() => {})
